import { useEffect, useRef, useState } from "react";
import Hwpllogo from "../assets/images/hwpllogo.png";
import { Link, NavLink, useLocation } from "react-router-dom";
import Moblogo from "../assets/images/Header/logo.png";

//import services image
import img1 from "../assets/images/Header/Services/branding-img.jpg";
import img2 from "../assets/images/Header/Services/business-process-automation-img.jpg";
import img3 from "../assets/images/Header/Services/cloud-computing-services-img.jpg";
import img4 from "../assets/images/Header/Services/cloud-server-solution-img.jpg";
import img5 from "../assets/images/Header/Services/cybersecurity-solutions-img.jpg";
import img6 from "../assets/images/Header/Services/digital-transformation-consulting-img.jpg";
import img7 from "../assets/images/Header/Services/domain-hosting-img.jpg";
import img8 from "../assets/images/Header/Services/erp-crm-solution-img.jpg";
import img9 from "../assets/images/Header/Services/ecommerce-development-img.jpg";
import img10 from "../assets/images/Header/Services/email-services-img.jpg";
import img11 from "../assets/images/Header/Services/graphics-design-img.jpg";
import img12 from "../assets/images/Header/Services/it-consulting-and-advisory-img.jpg";
import img13 from "../assets/images/Header/Services/it-infrastructure-management-img.jpg";
import img14 from "../assets/images/Header/Services/mobile-app-development-img.jpg";
import img15 from "../assets/images/Header/Services/website-development-img.jpg";


//import Technology images
import imge1 from "../assets/images/Header/Technology/ai-ml-img.jpg";
import imge2 from "../assets/images/Header/Technology/flutter-img.jpg";
import imge3 from "../assets/images/Header/Technology/html-css-img.jpg";
import imge4 from "../assets/images/Header/Technology/laravel-codeigniter-img.jpg";
import imge5 from "../assets/images/Header/Technology/php-mysql-img.jpg";
import imge6 from "../assets/images/Header/Technology/shopify-img.jpg";
import imge7 from "../assets/images/Header/Technology/wordpress-woocommerce-img.jpg";

//import Industries images
import imgs1 from "../assets/images/Header/Industries/bfsi-solution-img.jpg";
import imgs2 from "../assets/images/Header/Industries/doctors-img.jpg";
import imgs3 from "../assets/images/Header/Industries/ecommerce-img-ind.jpg";
import imgs4 from "../assets/images/Header/Industries/education-img.jpg";
import imgs5 from "../assets/images/Header/Industries/healthcare-img.jpg";
import imgs6 from "../assets/images/Header/Industries/logistics-img.jpg";
import imgs7 from "../assets/images/Header/Industries/product-manufacturer-img.jpg";
import imgs8 from "../assets/images/Header/Industries/real-estate-img.jpg";
import imgs9 from "../assets/images/Header/Industries/sports-gaming-img.jpg";

//import Products images
import product1 from "../assets/images/Header/Products/product1.jpg"
import product2 from "../assets/images/Header/Products/product2.jpg"
import product3 from "../assets/images/Header/Products/product3.jpg"
import product4 from "../assets/images/Header/Products/product4.jpg"

import "./stckyheader.css"

function StickyHeader({ onLinkClick }) {
    const [isSticky, setIsSticky] = useState(false);
    const [lastScroll, setLastScroll] = useState(0);

    useEffect(() => {
        const handleScroll = () => {
            const currentScroll = window.scrollY;

            if (currentScroll < lastScroll && currentScroll > 100) {
                // scrolling UP → SHOW
                setIsSticky(true);
            } else {
                // scrolling DOWN → HIDE
                setIsSticky(false);
            }

            setLastScroll(currentScroll);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [lastScroll]);



    const [stickyIsMenuOpen, setstickyIsMenuOpen] = useState(false);
    const [stickyCompanyOpen, setstickyCompanyOpen] = useState(false);
    const [stickyServicesOpen, setstickyServicesOpen] = useState(false);
    const [stickyTechnologyOpen, setstickyTechnologyOpen] = useState(false);
    const [stickyIndustriesOpen, setstickyIndustriesOpen] = useState(false);
    const [stickyProductsOpen, setstickyProductsOpen] = useState(false);
    const [activeHeader, setActiveHeader] = useState(null);
    const [activeService, setActiveService] = useState("branding");
    const [activeTechnology, setActiveTechnology] = useState("ai-ml");
    const [activeIndustrie, setActiveIndustrie] = useState("bfsi");
    const [activeProduct, setActiveProduct] = useState("attendance");


    const closeAllDropdowns = () => {
        setstickyCompanyOpen(false);
        setstickyServicesOpen(false);
        setstickyTechnologyOpen(false);
        setstickyIndustriesOpen(false);
        setstickyProductsOpen(false);
    };

    const location = useLocation();
    const path = location.pathname;

    // Determine if current path is under /company
    const isCompanyActive = location.pathname.includes("/company");
    const isActiveLi = (route) => path === route ? "active-li" : "";

    useEffect(() => {
        setActiveHeader(null);
    }, [location.pathname]);
    const getDefaultService = () => {
        const path = location.pathname;

        if (path.includes("business-process-automation")) return "bpa";
        if (path.includes("cloud-computing-services")) return "cloud";
        if (path.includes("cloud-server-solution")) return "server";
        if (path.includes("cybersecurity")) return "cyber";
        if (path.includes("digital-transformation")) return "digital";
        if (path.includes("domain-hosting")) return "domain";
        if (path.includes("erp-crm")) return "erp";
        if (path.includes("ecommerce")) return "ecom";
        if (path.includes("email-services")) return "email";
        if (path.includes("graphics-design")) return "graphics";
        if (path.includes("it-consulting")) return "consult";
        if (path.includes("it-infrastructure")) return "infra";
        if (path.includes("mobile-app-development")) return "mobile";
        if (path.includes("odoo")) return "odoo";
        if (path.includes("website-development")) return "web";

        return "bpa"; // ✅ default
    };

    const getDefaultTechnology = () => {
        const path = location.pathname;

        if (path.includes("flutter")) return "flutter";
        if (path.includes("html-css")) return "html-css";
        if (path.includes("laravel-codeigniter")) return "laravel";
        if (path.includes("php-mysql")) return "php-mysql";
        if (path.includes("shopify")) return "shopify";
        if (path.includes("wordpress-woocommerce")) return "wordpress";

        return "ai-ml"; // ✅ default
    };

    const getDefaultIndustrie = () => {
        const path = location.pathname;

        if (path.includes("doctors")) return "doctors";
        if (path.includes("e-commerce")) return "ecommerce";
        if (path.includes("education")) return "education";
        if (path.includes("healthcare")) return "healthcare";
        if (path.includes("logistics")) return "logistics";
        if (path.includes("product-manufacturer")) return "manufacturer";
        if (path.includes("real-estate")) return "realestate";
        if (path.includes("sports-gaming")) return "sports";

        return "bfsi"; // ✅ default
    }

    const getDefaultProduct = () => {
        const path = location.pathname;

        if (path.includes("lead-management")) return "Lead";
        if (path.includes("oddo-services")) return "odoo";
        if (path.includes("sales-accounting")) return "sales";

        return "attendance"; // ✅ default
    };


    return (
        <div className={`sticky-header ${isSticky ? "active" : ""}`}>
            <div className="header-lower">
                <div className="auto-container-sticky">
                    <div className="inner-container-sticky">
                        <div className="nav-outer d-flex">
                            {/* Logo & Hamburger Container */}
                            <div className="header-left">
                                {/* Logo Box */}
                                <div className="logo">
                                    <Link to="/" onClick={onLinkClick}>
                                        <img src={Moblogo} alt="" title="" />
                                    </Link>
                                </div>

                                {/* 🌟 Hamburger Button (visible only on mobile) */}
                                <button
                                    className="mobile-menu-toggle"
                                    onClick={() => {
                                        setstickyIsMenuOpen(!stickyIsMenuOpen);
                                        console.log("Toggled:", !stickyIsMenuOpen);
                                    }}
                                >
                                    {stickyIsMenuOpen ? (
                                        <i className="fa-solid fa-xmark"></i>   // Close icon
                                    ) : (
                                        <i className="fa-solid fa-bars"></i>    // Hamburger icon
                                    )}
                                </button>
                            </div>


                            {/* Main Menu */}
                            <nav className="main-menu show navbar-expand-md sticky-head sticker">
                                <div className="navbar-header">
                                    <button
                                        className="navbar-toggler"
                                        type="button"
                                        data-toggle="collapse"
                                        data-target="#navbarSupportedContent"
                                        aria-controls="navbarSupportedContent"
                                        aria-expanded="false"
                                        aria-label="Toggle navigation"
                                    >
                                        <span className="icon-bar" />
                                        <span className="icon-bar" />
                                        <span className="icon-bar" />
                                    </button>
                                </div>
                                <div
                                    className="navbar-collapse collapse clearfix"
                                    id="navbarSupportedContent"
                                >
                                    <ul className="navigation clearfix">
                                        <li>
                                            <NavLink
                                                to="/"
                                                className={({ isActive }) => isActive ? "active-link" : ""}
                                                onClick={onLinkClick}
                                            >
                                                HOME
                                            </NavLink>

                                        </li>
                                        <li className={`company-dropdown`}>
                                            <NavLink
                                                to="#"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();

                                                }}
                                                className={isCompanyActive ? "active-link" : ""}

                                            >
                                                COMPANY <i className="fas fa-angle-down"></i>
                                            </NavLink>



                                            <ul>
                                                <li>
                                                    <NavLink to="/company/about" onClick={onLinkClick} className={({ isActive }) => isActive ? "dropdown-active" : ""}>About Us</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/company/career" onClick={onLinkClick} className={({ isActive }) => isActive ? "dropdown-active" : ""}>Career</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/company/director" onClick={onLinkClick} className={({ isActive }) => isActive ? "dropdown-active" : ""}>Directors</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/company/our-team" onClick={onLinkClick} className={({ isActive }) => isActive ? "dropdown-active" : ""}>Our Team</NavLink>
                                                </li>
                                                <li>
                                                    <NavLink to="/company/testimonial" onClick={onLinkClick} className={({ isActive }) => isActive ? "dropdown-active" : ""}>Testimonial</NavLink>
                                                </li>
                                            </ul>
                                        </li>

                                        <li className={`mega-dropdown1 ${activeHeader === "services" ? "open" : ""}`}
                                            onMouseEnter={() => {
                                                setActiveHeader("services");
                                                setActiveService(getDefaultService());
                                            }}
                                            onMouseLeave={() => setActiveHeader(null)}
                                        >
                                            <NavLink
                                                to="/services"
                                                className={({ isActive }) => isActive ? "active-link" : ""}
                                                onClick={onLinkClick}
                                            >SERVICES <i class="fas fa-angle-down"></i></NavLink>

                                            <div className={`mega-menu-sticky mega-menu1-sticky`}>
                                                <div class="mega-left">
                                                    <ul>
                                                        {/* <li className={isActiveLi("/services/product-branding")} data-target="branding"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("branding")}
                                                        >
                                                            <NavLink to="/services/product-branding" onClick={onLinkClick}>Product Branding <i className="fas fa-angle-right"></i></NavLink>
                                                        </li> */}

                                                        <li className={isActiveLi("/services/business-process-automation")} data-target="bpa"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("bpa")}
                                                        >
                                                            <NavLink to="/services/business-process-automation" onClick={onLinkClick}>Business Process Automation <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/cloud-computing-services")} data-target="cloud"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("cloud")}
                                                        >
                                                            <NavLink to="/services/cloud-computing-services" onClick={onLinkClick}>Cloud Computing Services <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/cloud-server-solution")} data-target="server"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("server")}
                                                        >
                                                            <NavLink to="/services/cloud-server-solution" onClick={onLinkClick}>Cloud Server Solution <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/cybersecurity-solutions-ahmedabad")} data-target="cyber"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("cyber")}
                                                        >
                                                            <NavLink to="/services/cybersecurity-solutions-ahmedabad" onClick={onLinkClick}>Cybersecurity Solutions <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/digital-transformation-consulting")} data-target="digital"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("digital")}
                                                        >
                                                            <NavLink to="/services/digital-transformation-consulting" onClick={onLinkClick}>Digital Transformation Consulting <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/domain-hosting")} data-target="domain"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("domain")}
                                                        >
                                                            <NavLink to="/services/domain-hosting" onClick={onLinkClick}>Domain & Hosting <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>



                                                        <li className={isActiveLi("/services/ecommerce-development-ahmedabad")} data-target="ecom"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("ecom")}
                                                        >
                                                            <NavLink to="/services/ecommerce-development-ahmedabad" onClick={onLinkClick}>Ecommerce Development <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/email-services")} data-target="email"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("email")}
                                                        >
                                                            <NavLink to="/services/email-services" onClick={onLinkClick}>Email Services <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/erp-crm-solution")} data-target="erp"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("erp")}
                                                        >
                                                            <NavLink to="/services/erp-crm-solution" onClick={onLinkClick}>ERP/CRM Solution <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        {/* <li className={isActiveLi("/services/graphics-design")} data-target="graphics"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("graphics")}
                                                        >
                                                            <NavLink to="/services/graphics-design" onClick={onLinkClick}>Graphics Design <i className="fas fa-angle-right"></i></NavLink>
                                                        </li> */}

                                                        <li className={isActiveLi("/services/it-consulting-and-advisory")} data-target="consult"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("consult")}
                                                        >
                                                            <NavLink to="/services/it-consulting-and-advisory" onClick={onLinkClick}>IT Consulting and Advisory <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/it-infrastructure-management")} data-target="infra"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("infra")}
                                                        >
                                                            <NavLink to="/services/it-infrastructure-management" onClick={onLinkClick}>IT Infrastructure Management <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/mobile-app-development")} data-target="mobile"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("mobile")}
                                                        >
                                                            <NavLink to="/services/mobile-app-development" onClick={onLinkClick}>Mobile App Development <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>


                                                        <li className={isActiveLi("/odoo")} data-target="odoo"
                                                            onClick={() => setActiveHeader(null)} 
                                                            onMouseEnter={() => setActiveService("odoo")}
                                                        >
                                                            <NavLink to="/odoo" onClick={onLinkClick}>Odoo <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/services/website-development-in-ahmedabad")} data-target="web"
                                                            onClick={() => setActiveHeader(null)}  // ← Close menu on click
                                                            onMouseEnter={() => setActiveService("web")}
                                                        >
                                                            <NavLink to="/services/website-development-in-ahmedabad" onClick={onLinkClick}>Website Development <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>
                                                    </ul>

                                                </div>

                                                <div class="mega-right">
                                                    {/* <div id="branding" className={`content-item ${activeService === "branding" ? "active" : ""}`}>
                                                        <img src={img1} alt="" />
                                                        <h4><Link to="/services/product-branding" onClick={onLinkClick}>Product Branding</Link></h4>
                                                        <p>Transform your brand's identity with our bespoke design solutions. From captivating logos to cohesive visual storytelling, we specialize in crafting memorable brand experiences. Elevate your presence and resonate with your audience through our innovative design strategies. Let us shape your brand's narrative into a compelling visual journey that stands out in today's competitive landscape.</p>
                                                    </div> */}

                                                    <div id="bpa" className={`content-item ${activeService === "bpa" ? "active" : ""}`}>
                                                        <img src={img2} alt="" />
                                                        <h4><Link to="/services/business-process-automation" onClick={onLinkClick}>Business Process Automation</Link></h4>
                                                        <p>Revamp your operations with our Business Process Automation solutions. Streamline tasks, boost efficiency, and cut costs by integrating smart automation technologies tailored to your business needs. Elevate productivity and focus on growth while our solutions handle the repetitive tasks, empowering your team to excel.</p>
                                                    </div>

                                                    <div id="cloud" className={`content-item ${activeService === "cloud" ? "active" : ""}`}>
                                                        <img src={img3} alt="" />
                                                        <h4><Link to="/services/cloud-computing-services" onClick={onLinkClick}>Cloud Computing Services</Link></h4>
                                                        <p>In the ever-evolving digital landscape, Horizon Webinfo Pvt. Ltd. has been a trailblazer in delivering transformative Cloud Computing Services since our inception in 2005. As businesses increasingly turn to the cloud for agility, scalability, and innovation, we stand as your trusted partner in unlocking the full potential of cloud technologies.</p>
                                                    </div>

                                                    <div id="server" className={`content-item ${activeService === "server" ? "active" : ""}`}>
                                                        <img src={img4} alt="" />
                                                        <h4><Link to="/services/cloud-server-solution" onClick={onLinkClick}>Cloud Server Solution</Link></h4>
                                                        <p>Empower your business with our cutting-edge Cloud Server Solutions. Our robust infrastructure ensures seamless scalability, high performance, and unmatched security for your digital operations. Experience the flexibility of cloud computing tailored to meet your unique needs. Whether you're a startup or an enterprise, our customizable solutions offer reliability and efficiency, allowing you to focus on growth while we handle the technicalities. Explore our range of cloud services designed to elevate your business to new heights.</p>
                                                    </div>

                                                    <div id="cyber" className={`content-item ${activeService === "cyber" ? "active" : ""}`}>
                                                        <img src={img5} alt="" />
                                                        <h4><Link to="/services/cybersecurity-solutions-ahmedabad" onClick={onLinkClick}>Cybersecurity Solutions</Link></h4>
                                                        <p>In the dynamic realm of digital landscapes, cybersecurity is not just a necessity; it’s a cornerstone of business resilience. Horizon Webinfo Pvt. Ltd. has been a trusted guardian of digital assets, providing cutting-edge cybersecurity solutions since our inception in 2005. Our commitment to fortifying digital frontiers has made us a beacon of security in an ever-evolving threat landscape.</p>
                                                    </div>

                                                    <div id="digital" className={`content-item ${activeService === "digital" ? "active" : ""}`}>
                                                        <img src={img6} alt="" />
                                                        <h4><Link to="/services/digital-transformation-consulting" onClick={onLinkClick}>Digital Transformation Consulting</Link></h4>
                                                        <p>Embark on a transformative journey with our unparalleled Digital Transformation Consulting services. In a rapidly evolving digital landscape, staying ahead is not just an option; it’s imperative for success. At Horizon Webinfo Pvt. Ltd. we specialize in guiding organizations through comprehensive digital makeovers.</p>
                                                    </div>

                                                    <div id="domain" className={`content-item ${activeService === "domain" ? "active" : ""}`}>
                                                        <img src={img7} alt="" />
                                                        <h4><Link to="/services/domain-hosting" onClick={onLinkClick}>Domain & Hosting</Link></h4>
                                                        <p>Reliable and secure Domain & Hosting solutions tailored to your needs. Our services offer seamless website performance, robust security measures, and personalized support, ensuring a hassle-free online presence for your business. Explore our range of hosting packages and domain options to get started today.</p>
                                                    </div>



                                                    <div id="ecom" className={`content-item ${activeService === "ecom" ? "active" : ""}`}>
                                                        <img src={img9} alt="" />
                                                        <h4><Link to="/services/ecommerce-development-ahmedabad" onClick={onLinkClick}>Ecommerce Development</Link></h4>
                                                        <p>At Horizon Webinfo Pvt. Ltd. we specialize in crafting seamless E-commerce solutions that elevate your online business presence. Our team of dedicated developers harnesses cutting-edge technology to create user-friendly, secure, and scalable E-commerce platforms that drive sales and customer engagement.</p>
                                                    </div>

                                                    <div id="email" className={`content-item ${activeService === "email" ? "active" : ""}`}>
                                                        <img src={img10} alt="" />
                                                        <h4><Link to="/services/email-services" onClick={onLinkClick}>Email Services</Link></h4>
                                                        <p>Crafted by industry-leading experts, our Email Services ensure seamless communication. Experience top-tier reliability and efficiency through our tailored solutions. From campaign management to personalized outreach, we offer comprehensive Email Services designed to elevate your business. Connect with us to streamline your communication strategy and maximize your outreach potential.</p>
                                                    </div>

                                                    <div id="erp" className={`content-item ${activeService === "erp" ? "active" : ""}`}>
                                                        <img src={img8} alt="" />
                                                        <h4><Link to="/services/erp-crm-solution" onClick={onLinkClick}>ERP/CRM Solutions</Link></h4>
                                                        <p>Empower your business with our comprehensive ERP/CRM solutions. Seamlessly integrate and streamline operations, enhance productivity, and elevate customer experiences. Our tailored suite offers scalable, efficient tools designed to optimize workflows and drive growth, ensuring your business stays ahead in today's competitive landscape.</p>
                                                    </div>
                                                    {/* <div id="graphics" className={`content-item ${activeService === "graphics" ? "active" : ""}`}>
                                                        <img src={img11} alt="" />
                                                        <h4><Link to="/services/graphics-design" onClick={onLinkClick}>Graphics Design</Link></h4>
                                                        <p>Elevate your brand with captivating visuals and innovative design solutions. Our Graphic Design services bring creativity to life, delivering compelling logos, engaging marketing materials, and visually stunning branding assets. Let us craft designs that resonate with your audience, establishing a memorable and impactful brand presence.</p>
                                                    </div> */}

                                                    <div id="consult" className={`content-item ${activeService === "consult" ? "active" : ""}`}>
                                                        <img src={img12} alt="" />
                                                        <h4><Link to="/services/it-consulting-and-advisory" onClick={onLinkClick}>IT Consulting and Advisory</Link></h4>
                                                        <p>Horizon Webinfo Pvt. Ltd. stands as a beacon of expertise in IT Consulting and Advisory services, guiding businesses to navigate the complex and ever-evolving technology landscape since our inception in 2005. As a trusted partner, we bring strategic insights, technical prowess, and a commitment to innovation to help businesses leverage technology for optimal growth and success.</p>
                                                    </div>

                                                    <div id="infra" className={`content-item ${activeService === "infra" ? "active" : ""}`}>
                                                        <img src={img13} alt="" />
                                                        <h4><Link to="/services/it-infrastructure-management" onClick={onLinkClick}>IT Infrastructure Management</Link></h4>
                                                        <p>At Horizon Webinfo Pvt. Ltd. we take pride in our legacy of delivering top-notch IT Infrastructure Management solutions since our establishment in 2005. In an ever-evolving digital landscape, having a robust and well-managed IT infrastructure is crucial for the success of any business.</p>
                                                    </div>

                                                    <div id="mobile" className={`content-item ${activeService === "mobile" ? "active" : ""}`}>
                                                        <img src={img14} alt="" />
                                                        <h4><Link to="/services/mobile-app-development" onClick={onLinkClick}>Mobile App Development</Link></h4>
                                                        <p>Unlock innovation with our Mobile App Development expertise. We craft intuitive, custom-built apps for iOS and Android, ensuring seamless user experiences and leveraging cutting-edge technology. From concept to launch, we specialize in creating scalable solutions tailored to your unique business needs, driving engagement and success in the mobile sphere.</p>
                                                    </div>

                                                    <div id="odoo" className={`content-item ${activeService === "odoo" ? "active" : ""}`}>
                                                        <img src={product3} alt="" />
                                                        <h4><Link to="/odoo" onClick={onLinkClick}>Odoo</Link></h4>
                                                        <p>At Horizon Webinfo Pvt. Ltd. we empower businesses to streamline operations and scale efficiently with tailored Odoo ERP solutions. As an official Odoo development partner, we specialize in delivering end-to-end ERP services — from licensing and customization to implementation and long-term support.</p>
                                                    </div>

                                                    <div id="web" className={`content-item ${activeService === "web" ? "active" : ""}`}>
                                                        <img src={img15} alt="" />
                                                        <h4><Link to="/services/website-development-in-ahmedabad" onClick={onLinkClick}>Website Development</Link></h4>
                                                        <p>At Horizon Webinfo Pvt. Ltd. we specialize in crafting seamless E-commerce solutions that elevate your online business presence. Our team of dedicated developers harnesses cutting-edge technology to create user-friendly, secure, and scalable E-commerce platforms that drive sales and customer engagement.</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </li>
                                        <li className={`mega-dropdown1 ${activeHeader === "technology" ? "open" : ""}`}
                                            onMouseEnter={() => {
                                                setActiveHeader("technology");
                                                setActiveTechnology(getDefaultTechnology());
                                            }}
                                            onMouseLeave={() => setActiveHeader(null)}

                                        >
                                            <NavLink
                                                to="/technology"
                                                className={({ isActive }) => isActive ? "active-link" : ""}
                                                onClick={onLinkClick}
                                            >TECHNOLOGY <i class="fas fa-angle-down"></i></NavLink>

                                            <div class="mega-menu-sticky mega-menu2-sticky">
                                                <div class="mega-left">
                                                    <ul>
                                                        <li className={isActiveLi("/technology/ai-ml")} data-target="ai-ml" onMouseEnter={() => setActiveTechnology("ai-ml")}>
                                                            <NavLink to="/technology/ai-ml" onClick={onLinkClick}>AI/ML <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/technology/flutter")} data-target="flutter"
                                                            onMouseEnter={() => setActiveTechnology("flutter")}>
                                                            <NavLink to="/technology/flutter" onClick={onLinkClick}>Flutter <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/technology/html-css")} data-target="html-css"
                                                            onMouseEnter={() => setActiveTechnology("html-css")}>
                                                            <NavLink to="/technology/html-css" onClick={onLinkClick}>HTML/CSS <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/technology/laravel-codeigniter")} data-target="laravel"
                                                            onMouseEnter={() => setActiveTechnology("laravel")}>
                                                            <NavLink to="/technology/laravel-codeigniter" onClick={onLinkClick}>Laravel/Codeigniter <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/technology/php-mysql")} data-target="php-mysql"
                                                            onMouseEnter={() => setActiveTechnology("php-mysql")}>
                                                            <NavLink to="/technology/php-mysql" onClick={onLinkClick}>PHP/MYSQL <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/technology/shopify")} data-target="shopify"
                                                            onMouseEnter={() => setActiveTechnology("shopify")}>
                                                            <NavLink to="/technology/shopify" onClick={onLinkClick}>Shopify <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/technology/wordpress-woocommerce")} data-target="wordpress"
                                                            onMouseEnter={() => setActiveTechnology("wordpress")}>
                                                            <NavLink to="/technology/wordpress-woocommerce" onClick={onLinkClick}>WordPress/Woocommerce <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>
                                                    </ul>

                                                </div>


                                                <div class="mega-right">
                                                    <div id="ai-ml" className={`content-item ${activeTechnology === "ai-ml" ? "active" : ""}`}>
                                                        <img src={imge1} alt="" />
                                                        <h4><Link to="/technology/ai-ml" onClick={onLinkClick}>AI/ML</Link></h4>
                                                        <p>Revolutionize your business with cutting-edge AI/ML technology at our core. We harness the power of Artificial Intelligence and Machine Learning to craft innovative solutions tailored to your needs. Elevate your operations, optimize processes, and unlock unprecedented insights with our expertise driving your success. Join us on the forefront of technology for unparalleled growth and efficiency.</p>
                                                    </div>

                                                    <div id="flutter" className={`content-item ${activeTechnology === "flutter" ? "active" : ""}`}>
                                                        <img src={imge2} alt="" />
                                                        <h4><Link to="/technology/flutter" onClick={onLinkClick}>Flutter</Link></h4>
                                                        <p>Experience the power of Flutter technology with our company. We craft dynamic, cross-platform solutions that captivate users with stunning interfaces and seamless performance. Elevate your digital presence with our expertise in leveraging Flutter's versatility for your app development needs. Let's build remarkable experiences together.</p>
                                                    </div>

                                                    <div id="html-css" className={`content-item ${activeTechnology === "html-css" ? "active" : ""}`}>
                                                        <img src={imge3} alt="" />
                                                        <h4><Link to="/technology/html-css" onClick={onLinkClick}>HTML/CSS</Link></h4>
                                                        <p>Elevate your online presence with our mastery of HTML/CSS technology! At our web creation company, we harness the power of these fundamental languages to craft visually stunning and functional websites. From seamless layouts to responsive designs, our expertise ensures an unparalleled user experience.</p>
                                                    </div>

                                                    <div id="laravel" className={`content-item ${activeTechnology === "laravel" ? "active" : ""}`}>
                                                        <img src={imge4} alt="" />
                                                        <h4><Link to="/technology/laravel-codeigniter" onClick={onLinkClick}>Laravel/Codeigniter</Link></h4>
                                                        <p>Empower your web solutions with the prowess of Laravel and CodeIgniter. At our company, we harness the full potential of these robust PHP frameworks to craft dynamic, scalable, and customized websites tailored to your needs. From seamless functionality to elegant design, we elevate your online presence using the cutting-edge technologies of Laravel and CodeIgniter.</p>
                                                    </div>

                                                    <div id="php-mysql" className={`content-item ${activeTechnology === "php-mysql" ? "active" : ""}`}>
                                                        <img src={imge5} alt="" />
                                                        <h4><Link to="/technology/php-mysql" onClick={onLinkClick}>PHP/MYSQL</Link></h4>
                                                        <p>Empower your online presence with our PHP/MySQL expertise. Harnessing the power of PHP's versatility and MySQL's robustness, we craft dynamic and scalable solutions for your website. Our adept use of these technologies ensures seamless functionality, security, and efficiency, driving your digital success to new heights.</p>
                                                    </div>

                                                    <div id="shopify" className={`content-item ${activeTechnology === "shopify" ? "active" : ""}`}>
                                                        <img src={imge6} alt="" />
                                                        <h4><Link to="/technology/shopify" onClick={onLinkClick}>Shopify</Link></h4>
                                                        <p>Empower your e-commerce dreams with our cutting-edge use of Shopify technology. We harness its robust features to craft seamless, visually stunning online stores that captivate and convert. Our expertise in Shopify ensures your business thrives with intuitive design, secure transactions, and unparalleled user experience. Join us and elevate your online presence with the power of Shopify at your fingertips.</p>
                                                    </div>

                                                    <div id="wordpress" className={`content-item ${activeTechnology === "wordpress" ? "active" : ""}`}>
                                                        <img src={imge7} alt="" />
                                                        <h4><Link to="/technology/wordpress-woocommerce" onClick={onLinkClick}>WordPress/Woocommerce</Link></h4>
                                                        <p>Empower your online business with our expert utilization of WordPress/WooCommerce technology. Seamlessly manage and expand your e-commerce platform with our tailored solutions. Leverage the power of user-friendly interfaces and robust functionalities for a dynamic, customer-centric website. Elevate your online presence and drive sales with our specialized WordPress/WooCommerce expertise.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li className={`mega-dropdown1 ${activeHeader === "industries" ? "open" : ""}`}
                                            onMouseEnter={() => {
                                                setActiveHeader("industries");
                                                setActiveIndustrie(getDefaultIndustrie());
                                            }}
                                            onMouseLeave={() => setActiveHeader(null)}
                                        >
                                            <NavLink
                                                to="/industries"
                                                className={({ isActive }) => isActive ? "active-link" : ""}
                                                onClick={onLinkClick}
                                            >INDUSTRIES <i class="fas fa-angle-down"></i></NavLink>

                                            <div class="mega-menu-sticky mega-menu3-sticky">
                                                <div class="mega-left">
                                                    <ul>
                                                        <li className={isActiveLi("/industries/bfsi-solution")} data-target="bfsi"
                                                            onMouseEnter={() => setActiveIndustrie("bfsi")}>
                                                            <NavLink to="/industries/bfsi-solution" onClick={onLinkClick}>BFSI Solution <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/doctors")} data-target="doctors"
                                                            onMouseEnter={() => setActiveIndustrie("doctors")}>
                                                            <NavLink to="/industries/doctors" onClick={onLinkClick}>Doctors <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/e-commerce")} data-target="ecommerce"
                                                            onMouseEnter={() => setActiveIndustrie("ecommerce")}>
                                                            <NavLink to="/industries/e-commerce" onClick={onLinkClick}>E-commerce <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/education")} data-target="education"
                                                            onMouseEnter={() => setActiveIndustrie("education")}>
                                                            <NavLink to="/industries/education" onClick={onLinkClick}>Education <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/healthcare")} data-target="healthcare"
                                                            onMouseEnter={() => setActiveIndustrie("healthcare")}>
                                                            <NavLink to="/industries/healthcare" onClick={onLinkClick}>Healthcare <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/logistics")} data-target="logistics"
                                                            onMouseEnter={() => setActiveIndustrie("logistics")}>
                                                            <NavLink to="/industries/logistics" onClick={onLinkClick}>Logistics <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/product-manufacturer")} data-target="manufacturer"
                                                            onMouseEnter={() => setActiveIndustrie("manufacturer")}>
                                                            <NavLink to="/industries/product-manufacturer" onClick={onLinkClick}>Product Manufacturer <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/real-estate")} data-target="realestate"
                                                            onMouseEnter={() => setActiveIndustrie("realestate")}>
                                                            <NavLink to="/industries/real-estate" onClick={onLinkClick}>Real Estate <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/industries/sports-gaming")} data-target="sports"
                                                            onMouseEnter={() => setActiveIndustrie("sports")}>
                                                            <NavLink to="/industries/sports-gaming" onClick={onLinkClick}>Sports & Gaming <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>
                                                    </ul>

                                                </div>

                                                <div class="mega-right">
                                                    <div id="bfsi" className={`content-item ${activeIndustrie === "bfsi" ? "active" : ""}`}>
                                                        <img src={imgs1} alt="" />
                                                        <h4><Link to='/industries/bfsi-solution' onClick={onLinkClick}>BFSI Solution</Link></h4>
                                                        <p>Empowering BFSI sectors, our innovative IT solutions redefine efficiency and security. Leveraging cutting-edge technology, we craft tailored solutions for seamless financial operations. Partner with us to unlock the potential of your business and stay ahead in the ever-evolving financial landscape.</p>
                                                    </div>

                                                    <div id="doctors" className={`content-item ${activeIndustrie === "doctors" ? "active" : ""}`}>
                                                        <img src={imgs2} alt="" />
                                                        <h4><Link to='/industries/doctors' onClick={onLinkClick}>Doctors</Link></h4>
                                                        <p>Empower your medical practice with our cutting-edge IT solutions tailored for doctors' websites. From seamless appointment scheduling to secure patient portals, we craft user-friendly interfaces using innovative HTML/CSS technologies. Elevate your online presence and patient experience with our specialized digital solutions designed exclusively for healthcare professionals.</p>
                                                    </div>

                                                    <div id="ecommerce" className={`content-item ${activeIndustrie === "ecommerce" ? "active" : ""}`}>
                                                        <img src={imgs3} alt="" />
                                                        <h4><Link to='/industries/e-commerce' onClick={onLinkClick}>E-commerce</Link></h4>
                                                        <p>Empowering e-commerce industries through innovative IT solutions. Elevate your online presence with our tailored tech expertise. Streamline operations and boost sales with our cutting-edge IT services.</p>
                                                    </div>

                                                    <div id="education" className={`content-item ${activeIndustrie === "education" ? "active" : ""}`}>
                                                        <img src={imgs4} alt="" />
                                                        <h4><Link to='/industries/education' onClick={onLinkClick}>Education</Link></h4>
                                                        <p>Empowering education through innovative IT solutions, our company stands at the forefront of revolutionizing the education industry. Utilizing cutting-edge technology in web development, we craft tailored solutions to streamline learning experiences, facilitate collaboration, and optimize educational processes. From intuitive platforms to interactive interfaces, we pave the way for an enhanced, tech-driven educational landscape, fostering growth and knowledge dissemination.</p>
                                                    </div>

                                                    <div id="healthcare" className={`content-item ${activeIndustrie === "healthcare" ? "active" : ""}`}>
                                                        <img src={imgs5} alt="" />
                                                        <h4><Link to='/industries/healthcare' onClick={onLinkClick}>Healthcare</Link></h4>
                                                        <p>Empowering healthcare industries through innovative IT solutions, we specialize in crafting tailored software to streamline operations, enhance patient care, and optimize data management. Our cutting-edge technology harnesses the power of data analytics and secure systems, ensuring seamless integration and compliance with industry standards. Partner with us to revolutionize your healthcare services, delivering efficiency and quality care in the digital age.</p>
                                                    </div>

                                                    <div id="logistics" className={`content-item ${activeIndustrie === "logistics" ? "active" : ""}`}>
                                                        <img src={imgs6} alt="" />
                                                        <h4><Link to='/industries/logistics' onClick={onLinkClick}>Logistics</Link></h4>
                                                        <p>Empowering logistics industries through innovative IT solutions, we optimize operations, streamline processes, and enhance efficiency. Our tailored technology transforms logistics, offering robust systems tailored to meet industry-specific needs. From supply chain management to seamless operations, our IT services revolutionize the logistics landscape, ensuring reliability and agility in every step of the journey.</p>
                                                    </div>

                                                    <div id="manufacturer" className={`content-item ${activeIndustrie === "manufacturer" ? "active" : ""}`}>
                                                        <img src={imgs7} alt="" />
                                                        <h4><Link to='/industries/product-manufacturer' onClick={onLinkClick}>Product Manufacturer</Link></h4>
                                                        <p>Empowering product manufacturers across industries, our IT company pioneers tailored solutions using cutting-edge technology. We specialize in crafting innovative software and systems that optimize manufacturing processes, ensuring efficiency and growth. Elevate your production capabilities with our customized IT solutions and stay ahead in the competitive landscape.</p>
                                                    </div>

                                                    <div id="realestate" className={`content-item ${activeIndustrie === "realestate" ? "active" : ""}`}>
                                                        <img src={imgs8} alt="" />
                                                        <h4><Link to='/industries/real-estate' onClick={onLinkClick}>Real Estate</Link></h4>
                                                        <p>Empowering real estate with cutting-edge IT solutions. Elevate your property ventures with our tech-driven expertise. From streamlined management systems to immersive virtual experiences, we revolutionize real estate through innovation. Explore a new era of efficiency and growth with our tailored IT solutions for the property industry.</p>
                                                    </div>

                                                    <div id="sports" className={`content-item ${activeIndustrie === "sports" ? "active" : ""}`}>
                                                        <img src={imgs9} alt="" />
                                                        <h4><Link to='/industries/sports-gaming' onClick={onLinkClick}>Sports & Gaming</Link></h4>
                                                        <p>Immerse yourself in the world of sports and gaming with our cutting-edge website solutions tailored by our expert IT team. From dynamic interfaces to seamless user experiences, we elevate your platform's performance, offering responsive design and innovative features. Let us power your sports and gaming venture with HTML/CSS technology, delivering engaging, high-quality websites that captivate audiences and drive success.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                        <li className={`mega-dropdown1 ${activeHeader === "products" ? "open" : ""}`}
                                            onMouseEnter={() => {
                                                setActiveHeader("products");
                                                setActiveProduct(getDefaultProduct());
                                            }}
                                            onMouseLeave={() => setActiveHeader(null)}

                                        >
                                            <NavLink
                                                to="/products"
                                                className={({ isActive }) => isActive ? "active-link" : ""}
                                                onClick={onLinkClick}
                                            >PRODUCTS <i class="fas fa-angle-down"></i></NavLink>

                                            <div class="mega-menu-sticky mega-menu4-sticky">
                                                <div class="mega-left">
                                                    <ul>
                                                        <li className={isActiveLi("/products/attendance-system")} data-target="attendance"
                                                            onMouseEnter={() => setActiveProduct("attendance")}>
                                                            <NavLink to="/products/attendance-system" onClick={onLinkClick}>Attendance System <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/products/lead-management")} data-target="Lead"
                                                            onMouseEnter={() => setActiveProduct("Lead")}>
                                                            <NavLink to="/products/lead-management" onClick={onLinkClick}>Lead Management <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/products/oddo-services")} data-target="odoo"
                                                            onMouseEnter={() => setActiveProduct("odoo")}>
                                                            <NavLink to="/products/oddo-services" onClick={onLinkClick}>Odoo Services <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>

                                                        <li className={isActiveLi("/products/sales-accounting")} data-target="sales"
                                                            onMouseEnter={() => setActiveProduct("sales")}>
                                                            <NavLink to="/products/sales-accounting" onClick={onLinkClick}>Sales & Accounting <i className="fas fa-angle-right"></i></NavLink>
                                                        </li>
                                                    </ul>

                                                </div>


                                                <div class="mega-right">
                                                    <div id="attendance" className={`content-item ${activeProduct === "attendance" ? "active" : ""}`}>
                                                        <img src={product1} alt="" />
                                                        <h4><Link to='/products/attendance-system' onClick={onLinkClick}>Attendance System</Link></h4>
                                                        <p>At Horizon Webinfo Pvt. Ltd. we believe technology should simplify operations and enhance productivity. Our AI-powered Attendance & Payroll Automation System is designed to streamline HR processes, ensure accuracy, and bring complete transparency to workforce management.
                                                        </p>
                                                    </div>

                                                    <div id="Lead" className={`content-item ${activeProduct === "Lead" ? "active" : ""}`}>
                                                        <img src={product2} alt="" />
                                                        <h4><Link to='/products/lead-management' onClick={onLinkClick}>Lead Management</Link></h4>
                                                        <p>At Horizon Webinfo Pvt. Ltd. we empower businesses to convert more inquiries into customers through intelligent automation. Our Lead Management System centralizes, organizes, and optimizes every lead — ensuring fast response, improved follow-ups, and higher conversions.
                                                        </p>
                                                    </div>

                                                    <div id="odoo" className={`content-item ${activeProduct === "odoo" ? "active" : ""}`}>
                                                        <img src={product3} alt="" />
                                                        <h4><Link to='/products/oddo-services' onClick={onLinkClick}>Odoo Services</Link></h4>
                                                        <p>At Horizon Webinfo Pvt. Ltd. we empower businesses to streamline operations and scale efficiently with tailored Odoo ERP solutions. As an official Odoo development partner, we specialize in delivering end-to-end ERP services — from licensing and customization to implementation and long-term support.</p>
                                                    </div>

                                                    <div id="sales" className={`content-item ${activeProduct === "sales" ? "active" : ""}`}>
                                                        <img src={product4} alt="" />
                                                        <h4><Link to='/products/sales-accounting' onClick={onLinkClick}>Sales & Accounting</Link></h4>
                                                        <p> At Horizon Webinfo Pvt. Ltd. we help businesses streamline sales, purchasing, inventory, and accounting through a unified, intelligent management system. Designed for wholesalers, distributors, and retailers, our solution brings complete visibility and control over daily operations while reducing manual work.</p>
                                                    </div>

                                                </div>
                                            </div>
                                        </li>
                                        <li className={`mega-menu-item`}>
                                            <NavLink
                                                to="/odoo"
                                                className={({ isActive }) => isActive ? "active-link" : ""}
                                                onClick={onLinkClick}
                                            >
                                                ODOO
                                            </NavLink>

                                        </li>
                                        <li>
                                            <NavLink
                                                to="/contact-us"
                                                className={({ isActive }) => isActive ? "active-link" : ""}
                                                onClick={onLinkClick}
                                            >
                                                CONTACT US
                                            </NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
            {/* 🌟 MOBILE MENU SIDEBAR */}
            <div className={`hwpl-mobile-wrapper hwpl-mobile-sticky-wrapper ${stickyIsMenuOpen ? "open" : ""}`}>

                {/* Backdrop */}
                {stickyIsMenuOpen && (
                    <div
                        className="hwpl-backdrop"
                        onClick={() => setstickyIsMenuOpen(false)}
                    ></div>
                )}

                {/* SIDEBAR PANEL */}
                <nav className="hwpl-sidebar hwpl-sidebar-sticky" onClick={(e) => e.stopPropagation()}>

                    {/* Logo */}
                    <div className="hwpl-nav-logo">
                        <Link to="/" onClick={() => setstickyIsMenuOpen(false)}>
                            <img src={Hwpllogo} alt="HWPL Logo" />
                        </Link>
                    </div>

                    {/* MAIN MENU */}
                    <div className="hwpl-menu-outer">
                        <ul className="hwpl-mobile-nav">

                            {/* HOME */}
                            <li className="">
                                <NavLink
                                    to="/"
                                    className={({ isActive }) => isActive ? "active-link-mobile" : ""}
                                    onClick={() => setstickyIsMenuOpen(false)}
                                    style={{ color: '#000000', fontWeight: 500 }}
                                >
                                    HOME
                                </NavLink>
                            </li>

                            {/* COMPANY DROPDOWN */}
                            <li className="dropdown-item">
                                {/* Header row: text + arrow */}
                                <div className="dropdown-header" onClick={() => {
                                    closeAllDropdowns();
                                    setstickyCompanyOpen(!stickyCompanyOpen);
                                }}>
                                    {/* NavLink text — navigates */}
                                    {/* NavLink text — navigates */}
                                    <span
                                        className={`dropdown-link ${isCompanyActive ? "active-link" : ""}`}
                                        style={{ color: '#000000', fontWeight: 500 }}
                                    >
                                        COMPANY
                                    </span>
                                    {/* Arrow */}
                                    <i className={`fas fa-angle-down arrow-icon ${stickyCompanyOpen ? "arrow-up" : ""}`}></i>
                                </div>

                                {/* Submenu */}
                                {stickyCompanyOpen && (
                                    <ul className="submenu">
                                        {[
                                            ["about", "About Us"],
                                            ["career", "Career"],
                                            ["director", "Directors"],
                                            ["our-team", "Our Team"],
                                            ["testimonial", "Testimonial"]
                                        ].map(([slug, title]) => (
                                            <li key={slug}>
                                                <NavLink
                                                    to={`/company/${slug}`}
                                                    className={({ isActive }) => (isActive ? "dropdown-active" : "")}
                                                    onClick={() => {
                                                        setstickyIsMenuOpen(false);     // close sidebar
                                                        setstickyCompanyOpen(false); // 🔥 close industries dropdown
                                                        closeAllDropdowns();      // 🔥 safety reset
                                                    }}
                                                >
                                                    {title}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>



                            {/* SERVICES DROPDOWN (Same like COMPANY) */}
                            <li className="dropdown-item">
                                <div className="dropdown-header" onClick={() => {
                                    closeAllDropdowns();
                                    setstickyServicesOpen(!stickyServicesOpen);
                                }}>
                                    <NavLink
                                        to="/services"
                                        className={({ isActive }) =>
                                            `dropdown-link ${isActive ? "active-link" : ""}`
                                        }

                                        style={{ color: '#000000', fontWeight: 500 }}
                                        onClick={(e) => {
                                            e.stopPropagation();      // keep dropdown toggle safe
                                            setstickyServicesOpen(false);   // 👈 CLOSE dropdown
                                            setstickyIsMenuOpen(false);     // 👈 CLOSE sidebar
                                        }}
                                    >
                                        SERVICES
                                    </NavLink>
                                    {/* Arrow */}
                                    <i className={`fas fa-angle-down arrow-icon ${stickyServicesOpen ? "arrow-up" : ""}`}></i>
                                </div>

                                {stickyServicesOpen && (
                                    <ul className="submenu">
                                        {[
                                            ["business-process-automation", "Business Process Automation"],
                                            ["cloud-computing-services", "Cloud Computing Services"],
                                            ["cloud-server-solution", "Cloud Server Solution"],
                                            ["cybersecurity-solutions-ahmedabad", "Cybersecurity Solutions"],
                                            ["digital-transformation-consulting", "Digital Transform Consulting"],
                                            ["domain-hosting", "Domain & Hosting"],
                                            ["ecommerce-development-ahmedabad", "Ecommerce Development"],
                                            ["email-services", "Email Services"],
                                            ["erp-crm-solution", "ERP/CRM Solution"],
                                            ["it-consulting-and-advisory", "IT Consulting & Advisory"],
                                            ["it-infrastructure-management", "IT Infrastructure Management"],
                                            ["mobile-app-development", "Mobile App Development"],
                                            ["odoo", "Odoo"],
                                            ["website-development-in-ahmedabad", "Website Development"]
                                        ].map(([slug, title]) => (
                                            <li key={slug}>
                                                <NavLink
                                                    to={slug === "odoo" ? "/odoo" : `/services/${slug}`}
                                                    className={({ isActive }) => isActive ? "dropdown-active" : ""}
                                                    onClick={() => {
                                                        setstickyIsMenuOpen(false);     // close sidebar
                                                        setstickyServicesOpen(false); // 🔥 close industries dropdown
                                                        setActiveService(slug); // 🔥 update active state
                                                        closeAllDropdowns();      // 🔥 safety reset
                                                    }}
                                                >
                                                    {title}


                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>

                            {/* TECHNOLOGY DROPDOWN (Same as COMPANY & SERVICES) */}
                            <li className="dropdown-item">
                                <div className="dropdown-header" onClick={() => {
                                    closeAllDropdowns();
                                    setstickyTechnologyOpen(!stickyTechnologyOpen);
                                }}>
                                    <NavLink
                                        to="/technology"
                                        className={({ isActive }) =>
                                            `dropdown-link ${isActive ? "active-link" : ""}`
                                        }

                                        style={{ color: '#000000', fontWeight: 500 }}
                                        onClick={(e) => {
                                            e.stopPropagation();      // keep dropdown toggle safe
                                            setstickyTechnologyOpen(false);   // 👈 CLOSE dropdown
                                            setstickyIsMenuOpen(false);     // 👈 CLOSE sidebar
                                        }}
                                    >
                                        TECHNOLOGY
                                    </NavLink>
                                    {/* Arrow */}
                                    <i className={`fas fa-angle-down arrow-icon ${stickyTechnologyOpen ? "arrow-up" : ""}`}></i>
                                </div>
                                {stickyTechnologyOpen && (
                                    <ul className="submenu">
                                        {[
                                            ["ai-ml", "AI / ML"],
                                            ["flutter", "Flutter"],
                                            ["html-css", "HTML / CSS"],
                                            ["laravel-codeigniter", "Laravel / CodeIgniter"],
                                            ["php-mysql", "PHP / MySQL"],
                                            ["shopify", "Shopify"],
                                            ["wordpress-woocommerce", "WordPress / WooCommerce"]
                                        ].map(([slug, title]) => (
                                            <li key={slug}>
                                                <NavLink
                                                    to={`/technology/${slug}`}
                                                    className={({ isActive }) => isActive ? "dropdown-active" : ""}
                                                    onClick={() => {
                                                        setstickyIsMenuOpen(false);     // close sidebar
                                                        setstickyTechnologyOpen(false); // 🔥 close industries dropdown
                                                        setActiveTechnology(slug); // 🔥 update active state
                                                        closeAllDropdowns();      // 🔥 safety reset
                                                    }}
                                                >
                                                    {title}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                            {/* INDUSTRIES DROPDOWN (Same as TECHNOLOGY) */}
                            <li className="dropdown-item">
                                <div className="dropdown-header" onClick={() => {
                                    closeAllDropdowns();
                                    setstickyIndustriesOpen(!stickyIndustriesOpen);
                                }}>
                                    <NavLink
                                        to="/industries"
                                        className={({ isActive }) =>
                                            `dropdown-link ${isActive ? "active-link" : ""}`
                                        }

                                        style={{ color: '#000000', fontWeight: 500 }}
                                        onClick={(e) => {
                                            e.stopPropagation();      // keep dropdown toggle safe
                                            setstickyIndustriesOpen(false);   // 👈 CLOSE dropdown
                                            setstickyIsMenuOpen(false);     // 👈 CLOSE sidebar
                                        }}
                                    >
                                        INDUSTRIES
                                    </NavLink>
                                    {/* Arrow */}
                                    <i className={`fas fa-angle-down arrow-icon ${stickyIndustriesOpen ? "arrow-up" : ""}`}></i>
                                </div>

                                {stickyIndustriesOpen && (
                                    <ul className="submenu">
                                        {[
                                            ["bfsi-solution", "BFSI Solution"],
                                            ["doctors", "Doctors"],
                                            ["e-commerce", "E-commerce"],
                                            ["education", "Education"],
                                            ["healthcare", "Healthcare"],
                                            ["logistics", "Logistics"],
                                            ["product-manufacturer", "Product Manufacturer"],
                                            ["real-estate", "Real Estate"],
                                            ["sports-gaming", "Sports & Gaming"]
                                        ].map(([slug, title]) => (
                                            <li key={slug} className="w-full">
                                                <NavLink
                                                    to={`/industries/${slug}`}
                                                    className={({ isActive }) =>
                                                        `submenu-link ${isActive ? "dropdown-active" : ""}`
                                                    }
                                                    onClick={() => {
                                                        setstickyIsMenuOpen(false);     // close sidebar
                                                        setstickyIndustriesOpen(false); // 🔥 close industries dropdown
                                                        setActiveIndustrie(slug); // 🔥 update active state
                                                        closeAllDropdowns();      // 🔥 safety reset
                                                    }}
                                                >
                                                    {title}

                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>


                            {/* Product DROPDOWN (Same as COMPANY & SERVICES) */}
                            <li className="dropdown-item">
                                <div className="dropdown-header" onClick={() => {
                                    closeAllDropdowns();
                                    setstickyProductsOpen(!stickyProductsOpen);
                                }}>
                                    <NavLink
                                        to="/products"
                                        className={({ isActive }) =>
                                            `dropdown-link ${isActive ? "active-link" : ""}`
                                        }

                                        style={{ color: '#000000', fontWeight: 500 }}
                                        onClick={(e) => {
                                            e.stopPropagation();      // keep dropdown toggle safe
                                            setstickyProductsOpen(false);   // 👈 CLOSE dropdown
                                            setstickyIsMenuOpen(false);     // 👈 CLOSE sidebar
                                        }}
                                    >
                                        PRODUCTS
                                    </NavLink>
                                    {/* Arrow */}
                                    <i className={`fas fa-angle-down arrow-icon ${stickyProductsOpen ? "arrow-up" : ""}`}></i>
                                </div>

                                {stickyProductsOpen && (
                                    <ul className="submenu">
                                        {[
                                            ["attendance-system", "Attendance System"],
                                            ["lead-management", "Lead Management"],
                                            ["oddo-services", "Odoo Services"],
                                            ["sales-accounting", "Sales & Accounting"],

                                        ].map(([slug, title]) => (
                                            <li key={slug}>
                                                <NavLink
                                                    to={`/products/${slug}`}
                                                    className={({ isActive }) => isActive ? "dropdown-active" : ""}
                                                    onClick={() => {
                                                        setstickyIsMenuOpen(false);     // close sidebar
                                                        setstickyProductsOpen(false); // 🔥 close industries dropdown
                                                        setActiveProduct(slug); // 🔥 update active state
                                                        closeAllDropdowns();      // 🔥 safety reset
                                                    }}
                                                >
                                                    {title}
                                                </NavLink>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>

                            {/* ODOO */}
                            <li className="">
                                <NavLink
                                    to="/odoo"
                                    className={({ isActive }) => isActive ? "active-link" : ""}
                                    onClick={() => setstickyIsMenuOpen(false)}
                                    style={{ color: '#000000', fontWeight: 500 }}
                                >
                                    ODOO
                                </NavLink>
                            </li>
                            {/* Contact Us */}
                            <li className="">
                                <NavLink
                                    to="/contact-us"
                                    className={({ isActive }) => isActive ? "active-link" : ""}
                                    onClick={() => setstickyIsMenuOpen(false)}
                                    style={{ color: '#000000', fontWeight: 500 }}
                                >
                                    CONTACT US
                                </NavLink>
                            </li>

                        </ul>
                        {/* Social Box */}
                        <ul className="header-social_box mobile-social">
                            <li>
                                <a
                                    href="https://www.facebook.com/HorizonWebinfo/"
                                    className="fa-brands fa-facebook-f fa-fw"
                                    target="_blank"
                                />
                            </li>
                            <li>
                                <a
                                    href="https://x.com/hwplindia"
                                    className="fa-brands fa-twitter fa-fw"
                                    target="_blank"
                                />
                            </li>
                            <li>
                                <a
                                    href="https://www.instagram.com/hwplindia/"
                                    className="fa-solid fa-instagram fa-fw"
                                    target="_blank"
                                />
                            </li>
                            <li>
                                <a
                                    href="https://in.pinterest.com/hwplindia/"
                                    className="fa-solid fa-pinterest fa-fw"
                                    target="_blank"
                                />
                            </li>
                        </ul>
                    </div>
                </nav>
            </div>

        </div>
    );
}

export default StickyHeader;
